/*************************************************/
/* FORM                                          */
/*************************************************/

export function form(body, bodyLoadingClass) {
    const recaptchaResponseSelector = 'input[name="g-recaptcha-response"]';
    const recaptchaFieldSelector = '.recaptchav3withscore';
    var stringToHTML = function (str) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(str, 'text/html');
        return doc.body;
    };
    //There might be some things that seems strange regarding recaptcha, but that is because Umbraco is inconsistent with their implementation of form fields.
    //Also, the errors handling library that comes with Umbraco Forms is very closed off, so we have to handle the validation result manually
    const handleFormSubmission = async function (e, formContainer, formElement) {
        e.preventDefault();

        if (formContainer != null) {
            const form = formElement;
            if (formContainer.classList.contains('form-item--generic') && formContainer.classList.contains('form-item--post-async')) {
                const error = form.querySelector('.field-validation-error');
                const hasErrors = error != null;
                const isRecaptchaError = error?.closest(recaptchaFieldSelector) != null; //Check if the only error is a recaptcha error
                const formsResponse = form.querySelector('.umbraco-forms-response');
                if (formsResponse != null) {
                    formsResponse.remove();
                }

                if (!hasErrors || isRecaptchaError) { //Is there is no errors, or the only error is an invalid recaptcha, go ahead
                    error?.closest(recaptchaFieldSelector).classList.remove('has-error'); //Remove the marked recaptcha error
                    body.classList.add(bodyLoadingClass);
                    const recaptchaResponse = form.querySelector(recaptchaResponseSelector)?.value;
                    fetch(form.getAttribute('action'), {
                        method: 'POST',
                        body: new FormData(form),
                        headers: {
                            'g-recaptcha-response': recaptchaResponse //This is sent for validation, and is necessary
                        },
                    }).then(response => {
                        return response.text();
                    }).then(data => {
                        const responseBody = stringToHTML(data);

                        const message = responseBody.querySelector('.umbraco-forms-submitmessage');
                        if (message != null) {
                            form.dispatchEvent(new Event('reset'));
                            const div = document.createElement('div');
                            div.classList.add('umbraco-forms-response', 'umbraco-forms-response--success');
                            if (message != null) {
                                div.textContent = message.textContent;
                            }
                            form.appendChild(div);
                            window.dataLayer.push({
                                'event': 'formSubmission',
                                'formType': form.querySelector('input[name="FormName"]').value
                            });
                        } else {
                            const formParent = form.closest('.umbraco-forms-form');
                            const responseForm = responseBody.querySelector('#' + formParent.id);

                            const formErrors = responseForm.querySelectorAll('.field-validation-error')
                            if (formErrors != null) {
                                for (const formError of formErrors) {
                                    let isRecaptcha = false;
                                    const inputField = formError.closest('.umbraco-forms-field-wrapper').querySelector('input');
                                    let inputName = inputField.id;
                                    if (inputField.type == 'radio') {
                                        inputName = inputField.id.split('_')[0];
                                    }
                                    const originalInputField = document.querySelector('input[name="' + inputName + '"]');
                                    if (originalInputField == null) {
                                        originalInputField = document.querySelector(recaptchaResponseSelector);
                                        isRecaptcha = true;
                                    }
                                    if (originalInputField != null) {
                                        originalInputField.classList.add('input-validation-error');

                                        const originalValidationMessage = originalInputField.closest('.umbraco-forms-field-wrapper').querySelector('span[class^="field-validation"]');
                                        originalValidationMessage.classList.replace('field-validation-valid', 'field-validation-error');

                                        if (isRecaptcha) { //The recaptcha validation message is not stored in a data attribute, so we have to do this
                                            originalInputField.closest('.recaptchav3withscore').classList.add('has-error');
                                            originalValidationMessage.innerHTML = inputField.closest('.umbraco-forms-field-wrapper').querySelector('span[class^="field-validation"]').innerHTML;

                                        } else {//If not a recaptcha, the error is a "required" error, as these are triggered before regex errors. 
                                            originalValidationMessage.innerHTML = originalInputField.getAttribute('data-val-required');

                                        }
                                        if (originalInputField.hasAttribute('data-val-regex')) { //Check if this is a regex error.
                                            originalValidationMessage.innerHTML = originalInputField.getAttribute('data-val-regex');
                                        }
                                    }
                                }
                            }
                        }

                        body.classList.remove(bodyLoadingClass);



                    }).catch(err => {
                        console.log('Something went wrong in form.js');
                        console.error(err);
                        body.classList.remove(bodyLoadingClass);
                    });
                }
            }
        }
    }

    const init = () => {
        // Umbraco uses jQuery to add an event listener to Umbraco Forms' submit events. There is not way of removing that event, and it will always fire before any event we add.
        const forms = document.querySelectorAll('form');
        for (const formEle of forms) {

            if(formEle.id == "loginForm") continue;

            const formContainer = formEle.closest('.form-item');
            if (formContainer != null) {
                var submitButton = formEle.querySelector('input[type="submit"]');
                submitButton.addEventListener('click', (e) => {
                    handleFormSubmission(e, formContainer, formEle);
                });
            }

        };
    }

    init();
}
